// extracted by mini-css-extract-plugin
export default {"wrapper":"PreviewProfile_wrapper__Gq+Vs","wrapper__close":"PreviewProfile_wrapper__close__jx0qE"};